import { render } from "./service_layer_bindings.html?vue&type=template&id=2f79f7f4&external"
import script from "./service_layer_bindings.js?vue&type=script&lang=js&external"
export * from "./service_layer_bindings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__